export default __webpack_public_path__ + "static/media/kids_with_phone_3.79d44587.jpg";